import { render } from "./guidanceDetails.vue?vue&type=template&id=16c7233d&scoped=true"
import script from "./guidanceDetails.vue?vue&type=script&lang=js"
export * from "./guidanceDetails.vue?vue&type=script&lang=js"

import "./guidanceDetails.vue?vue&type=style&index=0&id=16c7233d&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c7233d"]])

export default __exports__